export const quickLinks = [
  {
    title: 'request.nav.addNewRequest',
    route: '/requests/add-new',
    permission: 'REQ_VIEW_MY_REQUESTS',
    visible: () => true
  },
  {
    title: 'request.nav.myRequests',
    route: '/requests/my-requests',
    permission: 'REQ_VIEW_MY_REQUESTS',
    visible: () => true
  }
]
